export default __webpack_public_path__ + "static/media/oregon.3b258912.jpg";